import a from "./_baseIsEqual.js";
import m from "./get.js";
import i from "./hasIn.js";
import s from "./_isKey.js";
import f from "./_isStrictComparable.js";
import _ from "./_matchesStrictComparable.js";
import n from "./_toKey.js";
var p = a, b = m, u = i, c = s, y = f, A = _, C = n, E = 1, l = 2;
function I(r, t) {
  return c(r) && y(t) ? A(C(r), t) : function(e) {
    var o = b(e, r);
    return o === void 0 && o === t ? u(e, r) : p(t, o, E | l);
  };
}
var h = I;
export {
  h as default
};
//# sourceMappingURL=_baseMatchesProperty.js.map
